import React from 'react';
import { KiteButton, KiteCard, KiteIcon } from '@kite/react-kite';
import './LocationCard.scss';
import { ITcoLocations } from 'types/TcoProducts';
import { tcoFormattedPrice } from 'utils/defaultsAndConstants/tcoConstants';

export interface ILocationCardProps {
  location: ITcoLocations;
  onEdit: (location: ITcoLocations) => void;
  onDelete: (location: ITcoLocations) => void;
  showLocationCount?: boolean;
}

const LocationCard = ({
  location,
  onEdit,
  onDelete,
  showLocationCount = false,
}: ILocationCardProps) => {
  const getSpectrumSubtotal = () => {
    const subtotal = location.underlaySelections.reduce((total, underlay) => {
      return total + underlay.spectrumPrice;
    }, 0);
    return tcoFormattedPrice(subtotal * location.noOfSites);
  };

  const getDiySubtotal = () => {
    const subtotal = location.underlaySelections.reduce((total, underlay) => {
      return total + underlay.diyPrice;
    }, 0);
    return tcoFormattedPrice(subtotal * location.noOfSites);
  };

  return (
    <KiteCard className="location-card tco-location-card">
      <div className="location-card__upper">
        <h3 className="location-card__upper_name">{location.name}</h3>
        <div className="location-card__upper_actions">
          <KiteButton
            type="standalone-link"
            aria-label="edit location"
            onClick={() => onEdit(location)}
          >
            <KiteIcon name="edit" />
          </KiteButton>
          <KiteButton
            type="standalone-link"
            aria-label="delete location"
            onClick={() => onDelete(location)}
          >
            <KiteIcon name="trash" />
          </KiteButton>
        </div>
      </div>

      <div className="location-card__lower">
        <div className="location-card__lower-pricing">
          <div className="location-card__lower-pricing-subtitle">SPECTRUM</div>
          <div className="location-card__lower-pricing-cost">
            <div>
              Circuits Subtotal
              <div className="location-card__lower-pricing-cost-value">
                ${getSpectrumSubtotal()}
              </div>
            </div>
          </div>
        </div>
        <div className="vertical"></div>
        <div className="location-card__lower-pricing">
          <div className="location-card__lower-pricing-subtitle">DIY</div>
          <div className="location-card__lower-pricing-cost">
            <div>
              Circuits Subtotal
              <div className="location-card__lower-pricing-cost-value">
                ${getDiySubtotal()}
              </div>
            </div>
          </div>
        </div>
        <div className="vertical"></div>
        <div className="location-card__lower-underlays">
          {showLocationCount && (
            <div className="location-card__lower-sites">
              <KiteIcon name="office" />
              <span>
                {location.noOfSites}{' '}
                {location.noOfSites === 1 ? 'Site' : 'Sites'}
              </span>
            </div>
          )}
          <div className="location-card__lower-sites">
            <KiteIcon name="network-alt" />
            <span>
              {location.underlaySelections.length}{' '}
              {location.underlaySelections.length === 1
                ? 'Underlay'
                : 'Underlays'}
            </span>
          </div>
        </div>
      </div>
    </KiteCard>
  );
};

export default LocationCard;
